import { z } from 'zod/v4';

import { entityStateSchema } from '../../../schemas/entity-state.schema';
import { coercedDate } from '../../../utils/coerced-date';

export const accountProductRelationshipSchema = z.object({
  accountState: entityStateSchema,
  expirationDate: coercedDate.nullable(),
  accountType: z.number().nullable(),
  maximumUsers: z.number().nullable(),
  phone: z.string().nullable(),
  manageOwnAPIKeys: z.boolean().nullable(),
});

export type AccountProductRelationship = z.infer<
  typeof accountProductRelationshipSchema
>;
